export enum PlanType {
  BASE = 'base',
  PREMIUM = 'premium',
  FREE = 'free',
}

export enum PaymentCycle {
  YEARLY = 12,
  MONTHLY = 1,
}

export interface ChangePlan {
  planId: number;
  paymentMethodId?: string;
}
